import axios from "axios";
import {apiKey} from '../Data/key.js'

const BASE_URL = "https://youtube138.p.rapidapi.com"
const options = {
    params: {
      hl: 'en',
      gl: 'US'
    },
    headers: {
      'X-RapidAPI-Key': apiKey.YOUTUBE_API_KEY,
      'X-RapidAPI-Host': 'youtube138.p.rapidapi.com'
    }
  };


export const fetchDataFromApi = async(url) => {
    const {data} = await axios.get(`${BASE_URL}/${url}`, options)
    return data;
}